export function cleanBenefitOrProductName(benefitOrProductName) {
  if (benefitOrProductName === '' || benefitOrProductName === ' ') {
    return '';
  }
  if (benefitOrProductName === undefined) {
    return undefined;
  }
  let originalString = benefitOrProductName.trim();
  let dashedString = originalString.replace(/ /g, '-').toLowerCase();

  return dashedString;
}
